import { Profilo, RichiestaMutuoNote, RichiestaMutuoRichiedente, Trascodifica } from './';

export class RichiestaMutuo {
  id: number;
	dataCreazione: Date;
	dataModifica: Date;
	durata: number;
	codiceCollaboratore: String;
	percentualeIntervento: number;
	importoRichiesto: number;
	massimoConcedibile: boolean;
	importoInvestimento: number;
	assAbitazione: Boolean;
	tutelaAffitto: Boolean;
	tutellaMutuo: Boolean;
	tutelaLegale: Boolean;
	protezioneVita: Boolean;
	idFinalita: number;
	idTasso: number;
	idStato: number;
	idProfilo: number;
	idStatoImmobile: number;
	note: String;
	noteRichiesta: Array<RichiestaMutuoNote>;

	finalita: Trascodifica;
	tasso: Trascodifica;
	nucleoFamiliare: Trascodifica;
	percettoriReddito: Trascodifica;
	stato: Trascodifica;
	statoImmobile: Trascodifica;
	profilo: Profilo;
	richiedenti: Array<RichiestaMutuoRichiedente>;
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/richiesta-mutuo.ts